import React, { useEffect, useRef, useState } from 'react'
import { Tab } from '@ya.praktikum/react-developer-burger-ui-components'
import IngredientCard from './ingredient-card/ingredient-card'
import styles from './burger-ingredients.module.css'
import { useAppSelector, useAppDispatch } from '../../services/hooks'
import { fetchIngredients } from '../../services/slices/ingredientsSlice'
import { addIngredient, removeIngredient } from '../../services/slices/constructorSlice'
import { Ingredient } from '../../services/types'

interface BurgerIngredientsProps {
	onIngredientClick: (ingredient: Ingredient) => void
}

const BurgerIngredients: React.FC<BurgerIngredientsProps> = ({
	onIngredientClick,
}) => {
	const dispatch = useAppDispatch()
	const {
		items: ingredients,
		loading,
		error,
	} = useAppSelector(state => state.ingredients)
	const { ingredients: constructorIngredients, bun: constructorBun } =
		useAppSelector(state => state.burgerConstructor)
	const [currentTab, setCurrentTab] = useState<'bun' | 'sauce' | 'main'>('bun')

	const bunRef = useRef<HTMLDivElement>(null)
	const sauceRef = useRef<HTMLDivElement>(null)
	const mainRef = useRef<HTMLDivElement>(null)

useEffect(() => {
		dispatch(fetchIngredients())
	}, [dispatch])

	const handleAddIngredient = (ingredient: Ingredient) => {
		if (ingredient.type === 'bun') {
			if (constructorBun?._id === ingredient._id) {
				return
			}
		}
		dispatch(addIngredient(ingredient))
	}

	const handleRemoveIngredient = (ingredient: Ingredient) => {
		if (ingredient.type === 'bun') {
			return
		}
		const items = constructorIngredients.filter(
			item => item._id === ingredient._id
		)
		if (items.length > 0) {
			dispatch(removeIngredient(items[0].uniqueId))
		}
	}

	const handleTabClick = (tab: 'bun' | 'sauce' | 'main') => {
		setCurrentTab(tab)
		const section = document.getElementById(
			tab === 'bun' ? 'buns' : tab === 'sauce' ? 'sauces' : 'mains'
		)
		if (section) {
			section.scrollIntoView({ behavior: 'smooth' })
		}
	}

	const buns = ingredients.filter(item => item.type === 'bun')
	const sauces = ingredients.filter(item => item.type === 'sauce')
	const mains = ingredients.filter(item => item.type === 'main')

	if (loading)
		return (
			<p className='text text_type_main-default'>Загрузка ингредиентов...</p>
		)
	if (error)
		return <p className='text text_type_main-default'>Ошибка: {error}</p>
	if (ingredients.length === 0)
		return (
			<p className='text text_type_main-default'>Нет доступных ингредиентов</p>
		)

	return (
		<section className={styles.ingredients}>
			<h1 className='text text_type_main-large mt-10 mb-5'>Соберите бургер</h1>

			<div className={styles.tabs}>
				<Tab
					value='bun'
					active={currentTab === 'bun'}
					onClick={() => handleTabClick('bun')}
				>
					Булки
				</Tab>
				<Tab
					value='sauce'
					active={currentTab === 'sauce'}
					onClick={() => handleTabClick('sauce')}
				>
					Соусы
				</Tab>
				<Tab
					value='main'
					active={currentTab === 'main'}
					onClick={() => handleTabClick('main')}
				>
					Начинки
				</Tab>
			</div>

			<div className={styles.scrollContainer}>
				<div className={styles.category} id='buns' ref={bunRef}>
					<h2 className='text text_type_main-medium mb-6'>Булки</h2>
					<div className={styles.items}>
						{buns.map(ingredient => (
							<IngredientCard
								key={ingredient._id}
								ingredient={ingredient}
								onIngredientClick={onIngredientClick}
								onAddClick={() => handleAddIngredient(ingredient)}
								count={
									constructorBun?._id === ingredient._id ? 2 : 0
								}
							/>
						))}
					</div>
				</div>

				<div className={styles.category} id='sauces' ref={sauceRef}>
					<h2 className='text text_type_main-medium mb-6'>Соусы</h2>
					<div className={styles.items}>
						{sauces.map(ingredient => (
							<IngredientCard
								key={ingredient._id}
								ingredient={ingredient}
								onIngredientClick={onIngredientClick}
								onAddClick={() => handleAddIngredient(ingredient)}
								onRemoveClick={() =>
									handleRemoveIngredient(ingredient)
								}
								count={
									constructorIngredients.filter(
										item => item._id === ingredient._id
									).length
								}
							/>
						))}
					</div>
				</div>

				<div className={styles.category} id='mains' ref={mainRef}>
					<h2 className='text text_type_main-medium mb-6'>Начинки</h2>
					<div className={styles.items}>
						{mains.map(ingredient => (
							<IngredientCard
								key={ingredient._id}
								ingredient={ingredient}
								onIngredientClick={onIngredientClick}
								onAddClick={() => handleAddIngredient(ingredient)}
								onRemoveClick={() =>
									handleRemoveIngredient(ingredient)
								}
								count={
									constructorIngredients.filter(
										item => item._id === ingredient._id
									).length
								}
							/>
						))}
					</div>
				</div>
			</div>
		</section>
	)
}

export default BurgerIngredients
